import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_REST_API_VSMS

export const _get = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: '/user',
    params: params,
  })

  return response?.data
}

export const get = (queryParamFilters) => async (queryParam) =>
  await _get(queryParamFilters, queryParam)
